<template>
  <div class="admin_container">
    <navigation/>
    <div class="categories">
      <router-link tag="div" class="category_button" to="admin/gallery">Galeria</router-link>
      <router-link tag="div" class="category_button" to="admin/offer">Oferta</router-link>
      <!-- <router-link tag="div" class="category_button" to="admin/contact">Kontakt</router-link> -->
      <!-- <router-link tag="div" class="category_button" to="admin/facebook">Facebook</router-link> -->
      <router-link tag="div" class="category_button" to="admin/texts">Teksty</router-link>
    </div>
    <Footer/>
  </div>
</template>

<script>
import Footer from '@/components/Footer.vue';
import navigation from '@/components/adminNav.vue';
import { mapState } from 'vuex';
export default {
  components:{
    Footer, navigation
  },
  computed:{
    ...mapState({
      user: state=>state.login.user
    })
  },
}
</script>

<style scoped lang="scss">
.categories{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 120px;
}
.category_button{
  width: 126px;
  height: 40px;
  border: 2px solid black;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 12px 0 6px;
  cursor: pointer;
  transition: .3s;
  &:hover{
    background: black;
    color: white;
  }
}
.footer_container{
  position: absolute;
  bottom: 0;
  width: 100%;
}
</style>